import { useEffect } from 'react'
import { loadBeamer } from '@/services/beamer'

export function useBeamer(userId: string | undefined) {
  useEffect(() => {
    if (userId)
      loadBeamer(userId)
  }, [userId])
}
